
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetoayodhyacab() {



    const cardData =
    {
        keyword: 'Pune to Ayodhya Cab',
        heading: 'S9 Travels: Pune to Ayodhya Cab',
        headingDescription: 'S9 Travels offers Pune to Ayodhya Cab Service, ensuring a comfortable, safe, and hassle-free journey to the sacred city. Whether you are traveling for pilgrimage or leisure, our well-maintained cabs, including spacious Innova vehicles, provide a smooth ride. Enjoy on-time pickups, professional drivers, affordable pricing, and 24/7 service for a seamless travel experience. Book your Pune to Ayodhya Cab with S9 Travels and embark on a stress-free journey to this divine destination!',


        top: 'Top Places to Visit in Ayodhya with S9 Travels',

"topPlaces": [
    {
      "title": "Shri Ram Janmabhoomi",
      "description": "One of the holiest sites in Hinduism, Shri Ram Janmabhoomi is believed to be the birthplace of Lord Rama. The grand temple dedicated to Lord Rama is a major pilgrimage destination, attracting devotees from all over India."
    },
    {
      "title": "Hanuman Garhi",
      "description": "A popular temple dedicated to Lord Hanuman, Hanuman Garhi is located on a hill and requires visitors to climb 76 steps. The temple offers breathtaking views of Ayodhya and is an important religious site for devotees."
    },
    {
      "title": "Kanak Bhawan",
      "description": "Kanak Bhawan is a beautiful temple dedicated to Lord Rama and Goddess Sita. Known for its stunning architecture and intricately designed idols, this temple holds great religious significance."
    },
    {
      "title": "Treta Ke Thakur",
      "description": "Believed to be the site where Lord Rama performed the Ashwamedha Yajna, Treta Ke Thakur is an ancient temple with statues of Lord Rama, Sita, Lakshmana, Bharat, and Shatrughan, carved out of a single black sandstone."
    },
    {
      "title": "Nageshwarnath Temple",
      "description": "Dedicated to Lord Shiva, Nageshwarnath Temple is believed to have been established by Kush, the son of Lord Rama. The temple holds a grand celebration during the festival of Shivratri."
    },
    {
      "title": "Guptar Ghat",
      "description": "Located on the banks of the Sarayu River, Guptar Ghat is believed to be the place where Lord Rama took Jal Samadhi. It is a serene spot where visitors can meditate and enjoy peaceful surroundings."
    },
    {
      "title": "Sita Ki Rasoi",
      "description": "An ancient temple believed to be the kitchen of Goddess Sita, Sita Ki Rasoi is now a sacred site that symbolizes her devotion and hospitality. Devotees offer food here as a form of worship."
    },
    {
      "title": "Mani Parvat",
      "description": "A small hill in Ayodhya, Mani Parvat is believed to be a part of the Sanjeevani Booti mountain carried by Lord Hanuman. It offers a panoramic view of Ayodhya and is a significant religious site."
    },
    {
      "title": "Choti Chawni",
      "description": "A beautiful structure built with white marble, Choti Chawni is a collection of temples and ashrams. It is an important religious site with spiritual significance."
    },
    {
      "title": "Tulsi Smarak Bhawan",
      "description": "Dedicated to the famous poet-saint Goswami Tulsidas, Tulsi Smarak Bhawan is a cultural center where devotees can learn about the life and works of the author of Ramcharitmanas."
    }
],

"services": [
  {
    "name": "Pune to Ayodhya Cab Service",
    "description": "Book a reliable and comfortable cab from Pune to Ayodhya with S9 Travels. We offer both one-way and round-trip options, ensuring a hassle-free journey to one of the most revered spiritual destinations in India. Our experienced drivers and well-maintained vehicles guarantee that your trip will be safe, comfortable, and timely, allowing you to focus on your pilgrimage and enjoy the scenic route."
  },
  {
    "name": "Book Pune to Ayodhya Taxi",
    "description": "Booking a taxi from Pune to Ayodhya is effortless with S9 Travels. Whether you need a one-way trip or prefer the flexibility of a round-trip, we provide tailored solutions for your travel preferences. Our professional drivers are familiar with the route and will ensure your journey is both comfortable and timely, giving you peace of mind throughout your trip to this holy city."
  },
  {
    "name": "Affordable Pune to Ayodhya Cab",
    "description": "Travel affordably from Pune to Ayodhya with S9 Travels. We offer budget-friendly cab services without compromising on quality or comfort. Whether you’re on a pilgrimage or a leisure trip, our affordable options ensure that your journey is not only easy on the wallet but also smooth and enjoyable, with experienced drivers ensuring your comfort along the way."
  },
  {
    "name": "Private Taxi for Ayodhya from Pune",
    "description": "Travel in privacy and luxury with a private taxi from Pune to Ayodhya. Our fleet of premium vehicles can be customized to suit your preferences, whether you're traveling alone or with family or friends. We ensure a quiet, comfortable, and uninterrupted journey, so you can focus on your pilgrimage while we handle the rest."
  },
  {
    "name": "Ayodhya Pilgrimage Cab from Pune",
    "description": "Book a dedicated pilgrimage cab for your trip from Pune to Ayodhya with S9 Travels. Our professional drivers are experienced in handling long-distance journeys and understand the significance of your visit. We ensure a safe and peaceful ride, taking care of all your needs during the journey so you can arrive at Ayodhya refreshed and ready for your spiritual experiences."
  },
  {
    "name": "Pune to Ayodhya One-Way or Round Trip",
    "description": "Need a one-way or round-trip taxi from Pune to Ayodhya? S9 Travels offers flexible booking options to suit your schedule and travel needs. Whether you need a quick one-way trip or prefer the convenience of a round trip, we’ll ensure that your travel is as seamless and stress-free as possible, with experienced drivers and well-maintained vehicles."
  },
  {
    "name": "Luxury Cab from Pune to Ayodhya",
    "description": "Travel in style and luxury from Pune to Ayodhya with our premium cab services. S9 Travels offers a range of luxury vehicles, including SUVs and sedans, to ensure that your journey is as comfortable and enjoyable as possible. With professional chauffeurs and top-of-the-line amenities, this is the ultimate way to experience a long-distance trip while traveling in style."
  },
  {
    "name": "Ayodhya Temple Trip by Taxi from Pune",
    "description": "Book a dedicated taxi for your Ayodhya temple trip from Pune with S9 Travels. Whether you’re visiting the renowned Ram Janmabhoomi or other holy sites, our taxis provide the perfect travel solution. Our experienced drivers ensure that your trip is smooth, on time, and comfortable, so you can focus on your spiritual journey rather than worrying about transportation."
  },
  {
    "name": "Comfortable Taxi Ride for Ayodhya",
    "description": "Experience a comfortable and relaxed taxi ride from Pune to Ayodhya with S9 Travels. Our fleet of well-maintained vehicles and skilled chauffeurs are dedicated to providing a stress-free journey, ensuring you arrive in Ayodhya feeling refreshed and ready for your spiritual trip. With excellent customer service and a focus on your comfort, we guarantee a pleasant travel experience."
  },
  {
    "name": "Group Travel to Ayodhya from Pune",
    "description": "Planning a group pilgrimage to Ayodhya from Pune? S9 Travels offers spacious and comfortable taxis that can accommodate large groups, making your trip enjoyable and convenient. Our vehicles are equipped to handle both the journey and the needs of your group, so you can travel together in comfort, while our experienced drivers ensure smooth and safe travel."
  },
  {
    "name": "Pune to Ayodhya Tour by Private Cab",
    "description": "Book a private cab for a personalized, seamless tour from Pune to Ayodhya. Our private cabs allow you to travel on your own schedule, with the added benefit of comfort and privacy. Whether it’s a spiritual pilgrimage or a personal tour of the city, our chauffeurs will guide you safely while ensuring your journey is pleasant, and we’ll make sure every detail of your trip is taken care of."
  }
],

"tableData": [
  ["Pune to Ayodhya Cab Service", "Book Pune to Ayodhya Taxi"],
  ["Affordable Pune to Ayodhya Cab", "Private Taxi for Ayodhya from Pune"],
  ["Ayodhya Pilgrimage Cab from Pune", "Pune to Ayodhya One-Way or Round Trip"],
  ["Luxury Cab from Pune to Ayodhya", "Ayodhya Temple Trip by Taxi from Pune"],
  ["Comfortable Taxi Ride for Ayodhya", "Group Travel to Ayodhya from Pune"],
  ["Pune to Ayodhya Tour by Private Cab", ""],
  ["", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Reliable Long-Distance Travel",
    "WhyChoosedescription": "S9 Travels offers a comfortable Pune to Ayodhya cab service, perfect for long-distance journeys. Our fleet of well-maintained vehicles, including the Toyota Innova, ensures a smooth, comfortable ride with ample space, air conditioning, and plush seating, making your trip enjoyable no matter the distance."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand that timely travel is essential. Our Pune to Ayodhya cab service ensures punctual pick-ups and drop-offs, so you can reach your destination on time without any delays. Whether you're traveling for business, leisure, or a special event, we guarantee reliable service every time."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes and road conditions for trips from Pune to Ayodhya. They prioritize safety, comfort, and efficiency, ensuring your journey is smooth and pleasant, no matter the destination."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for the Pune to Ayodhya cab service. We provide a transparent pricing structure with no hidden charges. You’ll receive a clear breakdown of the cost during the booking process, allowing you to plan your travel budget without surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Ayodhya Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features like GPS tracking, airbags, and seat belts to ensure a safe and comfortable journey for you and your passengers throughout your trip from Pune to Ayodhya."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Pune to Ayodhya trip. Whether you need an early morning departure or a late-night return, we’re here to provide reliable service that fits your travel schedule."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Ayodhya Trip",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you need to make stops along the way, have specific locations to visit, or require special arrangements, we offer customizable itineraries to suit your preferences and make your Pune to Ayodhya journey even more enjoyable."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Pune to Ayodhya cab with S9 Travels is simple and hassle-free. You can easily book your ride online through our website or mobile app, or contact our customer service team for personalized assistance. We strive to make your booking process quick, easy, and convenient."
  }
]

















    }


    const faqData = [
        [
          {
            question: 'How can I book a cab from Pune to Ayodhya with S9 Travels?',
            answer: 'Booking a cab from Pune to Ayodhya is easy! You can book your ride through our website, mobile app, or by contacting our customer service team for personalized assistance. We ensure a comfortable and seamless journey to Ayodhya.',
          },
          {
            question: 'What types of vehicles are available for a trip from Pune to Ayodhya?',
            answer: 'We offer a variety of vehicles for your trip from Pune to Ayodhya, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the one that best suits your needs based on your group size and preferences.',
          },
          {
            question: 'Are the drivers experienced for the Pune to Ayodhya trip?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes for the Pune to Ayodhya journey. They prioritize your safety, comfort, and a smooth travel experience.',
          },
          {
            question: 'Can I book a round-trip cab from Pune to Ayodhya?',
            answer: 'Yes, you can book a round-trip cab for your journey from Pune to Ayodhya. Just provide us with your return details, and we will ensure a timely and hassle-free return journey.',
          },
          {
            question: 'How long in advance should I book a cab for Pune to Ayodhya?',
            answer: 'It is recommended to book your cab at least 1-2 days in advance to secure vehicle availability. However, last-minute bookings are also possible based on availability.',
          },
          {
            question: 'Is there a fixed fare for the Pune to Ayodhya cab service?',
            answer: 'The fare for the Pune to Ayodhya trip depends on the distance, vehicle type, and other specific requirements. Contact us for a personalized quote with transparent pricing based on your trip details.',
          },
          {
            question: 'Do you offer pick-up services from Pune airport or hotels for the Ayodhya trip?',
            answer: 'Yes, we offer convenient pick-up services from Pune airport or hotels. Our professional drivers will ensure smooth transfer to your cab for a comfortable journey to Ayodhya.',
          },
          {
            question: 'Can I request additional stops along the way during my trip to Ayodhya?',
            answer: 'Yes, we can customize your itinerary by adding stops for meals, sightseeing, or other breaks during your journey to Ayodhya. Inform us at the time of booking to include your preferred stops.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Pune to Ayodhya trip?',
            answer: 'Any additional charges for waiting time or detours will be communicated to you upfront during the booking process. We maintain full transparency in our pricing.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Ayodhya trip?',
            answer: 'S9 Travels offers reliable, safe, and comfortable cab services for your journey from Pune to Ayodhya. With well-maintained vehicles, experienced drivers, and excellent customer service, we ensure a smooth and enjoyable trip.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Pune to Ayodhya with S9 Travels, and the experience was outstanding. The driver was courteous and professional, and the vehicle was clean and comfortable. The journey was smooth, and we made it to Ayodhya on time. I highly recommend S9 Travels for long-distance trips!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip from Pune to Ayodhya with S9 Travels was fantastic. The vehicle was spacious and well-maintained, and the driver was skilled and friendly. The entire journey was comfortable, and we enjoyed the scenic routes along the way. We’ll definitely use S9 Travels for our future trips!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Ayodhya Cab",
        "description": "Book affordable and reliable Pune to Ayodhya cab services for one-way trips, round trips, and pilgrimage tours. S9 Travels offers private taxi rides for a comfortable and scenic journey from Pune to Ayodhya, ideal for group travel, temple visits, and religious tours.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     


    return (
        <div>
        
        <Helmet>
        <title>Pune to Ayodhya Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune to Ayodhya taxi services, including one-way, round-trip, and private cabs. Comfortable and affordable transport for pilgrimage trips, group travel, and temple tours from Pune to Ayodhya with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
      
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/63.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoayodhyacab;